const number = new Intl.NumberFormat("fr-FR");

export function Pager({
  page,
  pageSize,
  total,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}) {
  const last = Math.max(1, Math.ceil(total / pageSize));
  const from = total ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(total, page * pageSize);
  return (
    <nav className="pager" aria-label="Pagination">
      <span className="pager__range">
        {number.format(from)}–{number.format(to)} sur {number.format(total)}
      </span>
      <button type="button" className="button button--quiet button--small" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        Précédent
      </button>
      <button
        type="button"
        className="button button--quiet button--small"
        disabled={page >= last}
        onClick={() => onPage(page + 1)}
      >
        Suivant
      </button>
    </nav>
  );
}
